var ProductMediaGrid = class extends HTMLElement {
    async connectedCallback() {
        // Verificar si el elemento tiene el atributo 'reveal-on-scroll'
        if (this.hasAttribute("reveal-on-scroll")) {
            this._setupVisibility();
        }

        document.addEventListener('variant:changed', this._onVariantChanged.bind(this));
       // Configurar eventos de clic para los botones de color
        var radios = document.querySelectorAll('.color-swatch__radio');
        radios.forEach(function(radio) {
            radio.addEventListener('click', function(e) {
                var mediaId = this.getAttribute('media-id');
                // Aquí puedes hacer algo con el mediaId si es necesario
            });
        });

        // Nuevo: leer el número de imágenes a mostrar
        this.imagesToShow = parseInt(this.getAttribute('data-images-count')) || 12; // Predeterminado a 12 si no se especifica
    }

    async _setupVisibility() {
        var imgElement = this.querySelector('img[reveal="true"]');
        if (imgElement) {
            imgElement.style.opacity = '1';
        } else {
            console.log('No img element with reveal=true found.');
        }
    }

    async _onVariantChanged(event) {
        this.selectedVariantMediaId = event.detail.variant["featured_media"] ? event.detail.variant["featured_media"]["id"] : null;

        // Obtener todos los elementos hermanos
        const allSiblings = [...document.querySelectorAll('.product__media-grid-item')];
        let nextElementIndex = allSiblings.findIndex(element => element.getAttribute('data-media-id') === String(this.selectedVariantMediaId));
        let counter = 0;

        // Bucle sobre todos los elementos hermanos
        for (let i = 0; i < allSiblings.length; i++) {
            // Si es el elemento actual o uno de los siguientes 'imagesToShow' hermanos,
            if (i >= nextElementIndex && counter < this.imagesToShow) {
                // Establecer el atributo 'data-visible' a 'true'
                allSiblings[i].setAttribute('data-visible', 'true');
                counter++;
            } else {
                // Establecer el atributo 'data-visible' a 'false' para los demás hermanos
                allSiblings[i].setAttribute('data-visible', 'false');
            }
        }
    }
}

// Definir el elemento personalizado
window.customElements.define("product-media-grid", ProductMediaGrid);
